import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../../../../../shared/services/http/http-client.service';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RolloutFuncionarioService {

  private readonly MIGRACAO_ROLLOUT_API = '/migracao-rollout/funcionario';

  constructor(
    private http: HttpClient,
    private httpService: HttpService
  ) { }

  listAll(successHandle: Function, errorHandle: Function) {
    this.httpService.doGet(`${this.MIGRACAO_ROLLOUT_API}/listar`, null, successHandle, errorHandle);
  }

  migrate(data: any, successHandle: Function, errorHandle: Function) {
    this.httpService.doPost(this.MIGRACAO_ROLLOUT_API, data, successHandle, errorHandle);
  }

  findBatchPaginatedByFilter(
    id: string,
    fileName: string,
    status: Set<string>,
    createStartDate: string,
    createEndDate: string,
    page: number,
    pageSize: number,
    successHandle: Function,
    errorHandle: Function
  ) {
    const params: any = {
      page: page.toString(),
      pageSize: pageSize.toString()
    };

    if (id) {
      params.id = id;
    }
    if (fileName) {
      params.fileName = fileName;
    }
    if (status && status.size > 0) {
      params.status = Array.from(status).join(',');
    }
    if (createStartDate) {
      params.createStartDate = createStartDate;
    }
    if (createEndDate) {
      params.createEndDate = createEndDate;
    }

    this.httpService.doGet(this.MIGRACAO_ROLLOUT_API, params, successHandle, errorHandle);
  }
}
